/* eslint-disable import/prefer-default-export */
export const GET_CLIENTS = 'GET_CLIENTS';
